// extracted by css-extract-rspack-plugin
export default {"cls1":"index-cls1_c27","cls2":"index-cls2_jJW index-cls1_c27"};